import { createI18n } from 'vue-i18n';
import en from './en';
import de from './de';

export function createAppI18n() {
    return createI18n({
        legacy: false,
        locale: navigator.language.startsWith('de') ? 'de' : 'en',
        fallbackLocale: 'en',
        messages: { en, de },
    });
}
